'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['t', 's', 'm', 'h', 'd'];


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/durationUnits.js
// module id = 22
// module chunks = 0